import IOSSwitch from '@/components/Switch';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface IProps {
  title: string;
  name: string;
  sx?: SxProps<Theme>;
  className?: string;
}

const SwitchToggle = ({ title, name, sx, className }: IProps) => {
  const { control } = useFormContext();

  const controlId = useMemo(() => `${name}_control`, [name]);

  return (
    <Box
      sx={{
        height: '47px',
        borderRadius: '8px',
        border: '1px solid rgb(228, 228, 228)',
        padding: '7px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...sx,
      }}
      className={className}
    >
      <label htmlFor={controlId} className='font-medium text-sm'>
        {title}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => <IOSSwitch {...field} id={controlId} checked={field.value} />}
      />
    </Box>
  );
};

export default SwitchToggle;
